import React, { useState } from 'react';
import { HeightOutlined } from '@mui/icons-material';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import SliderInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/SliderInput';
import SpacerBlock from './index';
export default function SpacerSidebarPanel({ data, setData }) {
    var _e;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = SpacerBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    return (React.createElement(BaseSidebarPanel, { title: "Spacer block" },
        React.createElement(SliderInput, { label: "Height", iconLabel: React.createElement(HeightOutlined, { sx: { color: 'text.secondary' } }), units: "px", step: 4, min: 4, max: 128, defaultValue: (_e = data.props) === null || _e === void 0 ? void 0 : _e.height, onChange: (height) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { height }) })) })));
}
//# sourceMappingURL=SpacerSidebarPanel.js.map